




























































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import axios, { AxiosInstance } from 'axios';
@Component({
    filters: {
        addCommas(val) {
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    }
})
export default class App extends Vue {
    cutTime: String;
    @Prop({
        default: '---',
        type: [Number, String]
    })
    Entity?: Number | String;

    @Prop({
        default: '---',
        type: [Number, String]
    })
    Relation?: Number | String;
    constructor() {
        super();
        const d = new Date(Date.now() - 1000 * 60 * 60 * 24);
        this.cutTime = `${d.getFullYear()}.${d.getMonth() +
            1}.${d.getDate()} 24:00`;
    }
    created() {
        axios
            .get('/finance-api/v1/latest/updateTime')
            .then(response => {
                if (response.status === 200) {
                    if (response.data.code === 200) {
                        this.cutTime = response.data.data;
                    }
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
}
